export default __webpack_public_path__ + "static/media/logo-slack.383191ac.svg";